import { Skeleton } from '@mui/material'
import React from 'react'

export const LeagueSkeleton = () => {
  return (
    <>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={30}
        sx={{ marginTop: '10px' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px ' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px ' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px ' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px ' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px ' }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        sx={{ marginTop: '10px ' }}
      />
    </>
  )
}
